import { render, staticRenderFns } from "./morales.vue?vue&type=template&id=9d803b56"
import script from "./morales.vue?vue&type=script&lang=js"
export * from "./morales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports